import "./Insights.module.css";
import Navigation from "@/reusable_sections/Header";
import Insights from "./sections/Insights";
import Newsletter from "./sections/Newsletter";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Navigation />
      <Insights />
      <Newsletter />
      <Footer />
    </div>;
}